import { render, staticRenderFns } from "./TreeView.vue?vue&type=template&id=4be619b2&"
import script from "./TreeView.vue?vue&type=script&lang=ts&"
export * from "./TreeView.vue?vue&type=script&lang=ts&"
import style0 from "./TreeView.vue?vue&type=style&index=0&id=4be619b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports